/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useRef } from "react";
import { Loader } from "@progress/kendo-react-indicators";
import { PDFExport } from "@progress/kendo-react-pdf";
import lynxLogo from "assets/images/logo.png";
import {
  useGetCashCenters,
  useGetCurrenciesList,
  useGetCustomers,
} from "utils/apis/lookups.api";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  Combobox,
  DatePicker,
} from "@repo/ui";
import { getCustomerLogo, isOperationAllowed, showToast } from "utils/helper";
import Layout from "components/layout";
import { useGetReportsCashDeliveries } from "utils/apis/reports.api";
import { Link } from "react-router-dom";
import CashDeliveriesReportGrid, {
  cashDeliveryReportPayload,
} from "./cashDeliveriesReportGrid";
import { formatDate } from "date-fns";
import { Permissions } from "utils/enums";

const currentDate = new Date();

function CashDeliveriesReport() {
  const [reportData, setReportData] = useState(null);
  const [ddlCashCenters, setDdlCashCenters] = useState("");
  const [cashCenter, setCashCenter] = useState("--");
  const [ddlCustomers, setDdlCustomers] = useState("");
  const [customer, setCustomer] = useState("All");
  const [ddlCurrencies, setDdlCurrencies] = useState("");
  const [currency, setCurrency] = useState("--");

  const [operationDate, setOperationDate] = useState(currentDate);
  const [reportName, setReportName] = useState("");
  const [reportDate, setReportDate] = useState("");

  const [loaderPanel, setLoaderPanel] = useState("d-none");
  const [disableDdlCc, setDisableDdlCc] = useState(false);
  const [disableDdlCustomers, setDisableDdlCustomers] = useState(false);
  const [disableDdlCurrencies, setDisableDdlCurrencies] = useState(false);
  const [disableTxtOpsDate, setDisableTxtOpsDate] = useState(false);

  const pdfExportComponent = useRef<any>(null);
  const excelExporter = useRef<any>(null);
  const nf = Intl.NumberFormat();

  const { data: cashCenters } = useGetCashCenters();
  const { data: customers } = useGetCustomers();
  const { data: currencies } = useGetCurrenciesList();

  useEffect(() => {
    const rptDate = `${(operationDate || currentDate).getDate()}/${
      (operationDate || currentDate).getMonth() + 1
    }/${(operationDate || currentDate).getFullYear()}`;
    setReportDate(rptDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function disableControls() {
    setDisableDdlCc(true);
    setDisableDdlCustomers(true);
    setDisableDdlCurrencies(true);
    setDisableTxtOpsDate(true);
    setLoaderPanel("d-block");
  }

  function enableControls() {
    setDisableDdlCc(false);
    setDisableDdlCustomers(false);
    setDisableDdlCurrencies(false);
    setDisableTxtOpsDate(false);
    setLoaderPanel("d-none");
  }

  const {
    data: citServicesData,
    mutate: generateReportRequest,
    error,
    isPending,
  } = useGetReportsCashDeliveries();

  useEffect(() => {
    if (citServicesData) {
      const reqsList = citServicesData?.map((req: any, ind: number) => ({
        serialNo: ++ind,
        customer: req.customer,
        location: req.location,
        accountNo: req.accountNo,
        notes: req.notes,
        coins: req.coins,
        totalAmount: req.totalAmount,
        remarks: req.remarks,
      }));

      setReportData(reqsList);
      enableControls();
    }
    if (error) {
      setReportData(null);
      setLoaderPanel("d-none");
      showToast("error", "No data found.");
      enableControls();
    }
  }, [citServicesData, error]);

  const onDdlCashCentersChanged = (value: string) => {
    setDdlCashCenters(value);
    if (!value) {
      setDdlCashCenters("");
      setCashCenter("--");
    } else {
      setCashCenter(value);
    }
  };

  const onDdlCustomersChanged = (value: string) => {
    setDdlCustomers(value);
    if (!value) {
      setDdlCustomers("");
      setCustomer("--");
    } else setCustomer(value);
  };

  const onDdlCurrenciesChanged = (value: string) => {
    setDdlCurrencies(value);
    if (!value) {
      setDdlCurrencies("");
      setCurrency("--");
    } else setCurrency(value);
  };

  const txtOpsDateChanged = (date?: Date) => {
    if (date) {
      setOperationDate(date);

      const rptDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;

      setReportDate(rptDate);
    }
  };

  const onBtnGenerateReportClicked = () => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    if (!ddlCustomers) {
      showToast("error", "Please select customer.");
      return;
    }

    if (!ddlCurrencies) {
      showToast("error", "Please select currency.");
      return;
    }

    const cashCenterId = ddlCashCenters;
    const customerId = ddlCustomers;
    const selCurrency = ddlCurrencies;

    const reportParams = {
      customerId,
      cashCenterId,
      currency: selCurrency,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'"
      ),
    };

    generateReportRequest(reportParams);
    disableControls();
    setReportName(
      `Cash_Deliveries_${(operationDate || currentDate).getDate()}/${
        (operationDate || currentDate).getMonth() + 1
      }/${(operationDate || currentDate).getFullYear()}`
    );
  };

  const exportToPDF = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };
  const exportToExcel = () => {
    if (excelExporter.current) {
      const {
        deliveries,
        notesDenominations,
        coinsDenominations,
        notesTotals,
        coinsTotals,
        netBankNotes,
        grandTotalAmount,
      } = cashDeliveryReportPayload(reportData || []);

      const options = excelExporter.current.workbookOptions();
      options.sheets[0].columns = options.sheets[0].columns
        .concat(
          new Array(coinsDenominations.length).fill({
            width: NaN,
            autoWidth: true,
          })
        )
        .concat(
          new Array(notesDenominations.length).fill({
            width: NaN,
            autoWidth: true,
          })
        );
      const rows = options.sheets[0].rows;
      rows[0].cells.forEach((cell: any) => {
        cell.rowSpan = 2;
      });
      let splitIndex = 4;
      if (coinsDenominations.length > 0) {
        splitIndex = 5;
        rows[0].cells.splice(4, 0, {
          background: "#7a7a7a",
          color: "#fff",
          textAlign: "center",
          value: "Coins",
          colSpan: coinsDenominations.length,
          firstCell: true,
          rowSpan: 1,
          borderBottom: true,
          borderLeft: true,
          borderRight: true,
        });
      }
      if (notesDenominations.length > 0) {
        rows[0].cells.splice(
          splitIndex,
          0,

          {
            background: "#7a7a7a",
            color: "#fff",
            textAlign: "center",
            value: "Notes",
            colSpan: notesDenominations.length,
            firstCell: true,
            rowSpan: 1,
            borderBottom: true,
            borderLeft: true,
            borderRight: true,
          }
        );
      }
      let coinsNotesArray: any = [];
      if (coinsDenominations.length > 0) {
        coinsNotesArray = coinsDenominations.map((coin: any) => {
          const temp = {
            background: "#7a7a7a",
            colSpan: 1,
            color: "#fff",
            firstCell: true,
            rowSpan: 1,
            borderLeft: true,
            borderRight: true,
            value: coin.denomination,
          };
          return temp;
        });
      }
      if (notesDenominations.length > 0) {
        coinsNotesArray = coinsNotesArray.concat(
          notesDenominations.map((coin: any) => {
            const temp = {
              background: "#7a7a7a",
              colSpan: 1,
              color: "#fff",
              firstCell: true,
              rowSpan: 1,

              borderLeft: true,
              borderRight: true,
              value: coin.denomination,
            };
            return temp;
          })
        );
      }
      if (coinsNotesArray.length > 0) {
        rows.splice(1, 0, {
          type: "header",
          cells: coinsNotesArray,
        });
      }

      const cellOptions = { bold: true, borderBottom: true };

      rows.unshift(
        {
          type: "data",
          cells: [
            {
              value: `Cash Center: ${cashCenters?.find((item) => item.cashCenterId === cashCenter)?.name || ""}`,
              ...cellOptions,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `Bank Name: ${customers?.find((item) => item.customerId === customer)?.name || ""}`,
              ...cellOptions,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `Currency: ${currency}`,
              ...cellOptions,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `Report Date: ${reportDate}`,
              ...cellOptions,
            },
          ],
        }
      );

      options.sheets[0].freezePane.rowSplit = 6;
      if (coinsNotesArray.length > 0) {
        for (let i = 6; i < rows.length; i++) {
          const coins = deliveries[i - 6].coins;
          const notes = deliveries[i - 6].notes;
          const notesArray: any = [];
          const coinsArray: any = [];
          coinsDenominations.forEach((elm: any) => {
            if (elm.denomination in coins) {
              coinsArray.push({ value: nf.format(coins[elm.denomination]) });
            } else {
              coinsArray.push({ value: "0" });
            }
          });
          notesDenominations.forEach((elm: any) => {
            if (elm.denomination in notes) {
              coinsArray.push({ value: nf.format(notes[elm.denomination]) });
            } else {
              coinsArray.push({ value: "0" });
            }
          });
          rows[i].cells = rows[i].cells
            .splice(0, 4)
            .concat(coinsArray)
            .concat(notesArray)
            .concat(rows[i].cells);
        }
      }

      const totalNotes = notesDenominations.map((dnm: any) => {
        const denom = dnm.denomination;
        let total = 0;

        notesTotals.forEach((ct: any) => {
          total += ct[denom] ? ct[denom] : 0;
        });
        return { value: nf.format(total), bold: true };
      });

      const totalCoins = coinsDenominations.map((dnm: any) => {
        const denom = dnm.denomination;
        let total = 0;

        coinsTotals.forEach((ct: any) => {
          total += ct[denom] ? ct[denom] : 0;
        });
        return { value: nf.format(total), bold: true };
      });

      rows.push({
        type: "footer",
        level: 0,
        cells: [
          {
            colSpan: 4,
            bold: true,
            textAlign: "center",
            value: "Total",
          },

          ...totalCoins,
          ...totalNotes,
          { bold: true, value: nf.format(netBankNotes) },
          { bold: true, value: nf.format(grandTotalAmount) },
        ],
      });
      excelExporter.current.save(options);
    }
  };
  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Reports</BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Daily Cash Delivery Report</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex gap-3">
              <div className="flex-1">
                <Combobox
                  disabled={disableDdlCc}
                  placeholder="Select Cash center"
                  value={ddlCashCenters}
                  data={cashCenters?.map((item) => ({
                    value: item?.cashCenterId,
                    label: item?.name,
                  }))}
                  setValue={onDdlCashCentersChanged}
                />
              </div>

              <div className="flex-1">
                <Combobox
                  disabled={disableDdlCustomers}
                  placeholder="Select Customer"
                  value={ddlCustomers}
                  data={customers?.map((item) => ({
                    value: item?.customerId,
                    label: item?.name,
                  }))}
                  setValue={onDdlCustomersChanged}
                />
              </div>

              <div className="flex-1">
                <Combobox
                  disabled={disableDdlCurrencies}
                  placeholder="Select Currency"
                  value={ddlCurrencies}
                  data={currencies?.map((item: any) => ({
                    value: item?.shortName,
                    label: item?.name,
                  }))}
                  setValue={onDdlCurrenciesChanged}
                />
              </div>

              <div className="flex-1">
                <DatePicker
                  disabled={disableTxtOpsDate}
                  placeholder="Select Operations Date"
                  selectedDate={operationDate}
                  onSelectDate={txtOpsDateChanged}
                />
              </div>

              <div className="flex gap-3">
                <Button
                  variant="secondary"
                  onClick={onBtnGenerateReportClicked}
                  isLoading={isPending}
                >
                  Get Report
                </Button>

                {isOperationAllowed(
                  Permissions.Report,
                  Permissions.PdfExport
                ) ? (
                  <Button variant="secondary" onClick={exportToPDF}>
                    <svg
                      viewBox="0 0 512 512"
                      fill="currentColor"
                      className="w-6"
                    >
                      <path d="M240.9 160c-7.6 0-13.8 4-15.4 9.9-4.9 18.6.2 46.3 9.4 82.3l-2.4 5.9c-6.6 16.4-14.8 33-22.1 47.6l-1 1.9c-7.7 15.3-14.6 28.4-21 39.4l-6.5 3.5c-.5.3-11.6 6.3-14.3 7.9-22.2 13.6-36.9 28.9-39.4 41.2-.8 3.9-.2 8.9 3.7 11.2l6.3 3.2c2.7 1.4 5.6 2.1 8.6 2.1 15.8 0 34.2-20.2 59.5-65.3 29.2-9.7 62.5-17.8 91.6-22.3 22.2 12.8 49.5 21.7 66.8 21.7q4.65 0 7.8-.9c3.3-.9 6.1-2.8 7.8-5.4 3.4-5.2 4-12.2 3.1-19.5-.3-2.1-2-4.8-3.8-6.6-5.1-5.2-16.5-7.9-33.7-8.1-11.7-.1-25.8.9-40.6 3-6.6-3.9-13.5-8.2-18.8-13.3-14.4-13.8-26.5-32.9-34-53.9.5-2 .9-3.7 1.3-5.4 0 0 8.1-47.1 6-63.1-.3-2.2-.5-2.8-1.1-4.5l-.7-1.9c-2.2-5.2-6.5-10.7-13.3-10.4zm2.7 8.4c5.1 0 8 13.1 8.2 25.4.3 12.3-2.6 20.9-6 27.3-2.9-9.4-4.3-24.3-4.3-34-.1-.1-.3-18.7 2.1-18.7m.4 104.1c8.6 16 19.3 29.5 31.9 40.4 1.6 1.3 3.2 2.7 5 4.1-25.6 5.2-47.7 11.5-67.1 19.1 3.6-6.5 7.2-13.3 11-20.6 9.1-17.7 14.9-31.6 19.2-43m102.2 51.6c9.3 0 12 0 21.1 2.3 9.1 2.4 9.2 7.2 7.6 8.2s-6 1.6-8.9 1.6c-9.2 0-20.7-4.3-36.8-11.4 6.3-.4 11.9-.7 17-.7m-165.4 35.8c-17.7 28.8-29.5 40.3-37.3 43.8 2.9-8.1 14.3-24 31.2-38.1 1.1-.9 3.7-3.4 6.1-5.7M352 32H96c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V128zm64 416H96V64h224v96h96z" />
                    </svg>
                  </Button>
                ) : null}
                {isOperationAllowed(
                  Permissions.Report,
                  Permissions.ExcelExport
                ) ? (
                  <Button variant="secondary" onClick={exportToExcel}>
                    <svg
                      viewBox="0 0 512 512"
                      fill="currentColor"
                      className="w-6"
                    >
                      <path d="m288 304 64 112h-48l-48-84.5-31.5 52.5H256v32h-96l64-112-64-112h48l48 84 48-84h48zm64-272H96c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V128zm64 416H96V64h224v96h96z" />
                    </svg>
                  </Button>
                ) : null}
              </div>
            </div>
            <div className="border-b my-3 bg-accent" />
            <div className={`text-center ${loaderPanel}`}>
              <Loader size="large" type="converging-spinner" />
            </div>
            <PDFExport
              scale={0.3}
              ref={pdfExportComponent}
              paperSize="A4"
              fileName={reportName}
            >
              <div className="flex gap-5 items-center pt-6">
                <div className="max-w-48 w-full text-end">
                  <img src={lynxLogo} className="w-full" alt="logo" />
                </div>

                <div className="flex-[3]">
                  <span className="text-primary-darken-3 h6">{`Cash Center: ${cashCenters?.find((item) => item.cashCenterId === cashCenter)?.name || ""}`}</span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                  <span className="text-primary-darken-3 h6">{`Bank Name: ${customers?.find((item) => item.customerId === customer)?.name || ""}`}</span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                  <span className="text-primary-darken-3 h6">{`Currency: ${currency}`}</span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                  <span className="text-primary-darken-3 h6">{`Report Date: ${reportDate}`}</span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                </div>

                <div className="flex-[3] text-center">
                  <h5>
                    <u>Daily Cash Deliveries</u>
                  </h5>
                </div>

                <div className="flex-1 text-start">
                  <img src={getCustomerLogo()} alt="logo" />
                </div>
              </div>
              <div className="mt-3 ">
                {reportData ? (
                  <CashDeliveriesReportGrid requests={reportData} />
                ) : null}
              </div>
            </PDFExport>
            <CashDeliveriesReportGrid
              excelView
              requests={reportData || []}
              excelRef={excelExporter}
              fileName={reportName}
            />
          </CardDescription>
        </CardContent>
      </Card>
    </Layout>
  );
}

export default CashDeliveriesReport;
